export default "__VITE_ASSET__d8d3b19c__"